import React, { useMemo } from 'react'
import Image from 'next/image'
import { Container, Grid, Segment } from 'semantic-ui-react'

import { Button } from 'components/Common'
import AppointmentBookingModal from 'components/Appointments/AppointmentBookingModal'
import { ProviderInfo } from '../components/ProviderCard/components'
import Images from 'images'
import { ProfileOverview } from './components'

import useMediaQuery from 'hooks/useMediaQuery'

import { defaultStyles as styles } from './styles'

export const ProfileViewComponent = ({
  isCareTeam = false,
  goToProviders,
  provider,
  openBookingCheck,
  isOpenModal,
  openBookingModal,
  goToMessages,
  isBookingDataLoading,
  bookingData,
  getBookingData,
  isBookAppointmentLoading,
  bookAppointmentStatus,
  bookAppointment,
  resetBooking,
  setIsOpenModal
}) => {
  const { isMobile, isTablet } = useMediaQuery()

  const isCanOpenModal = useMemo(() => {
    return isOpenModal && openBookingCheck()
  }, [isOpenModal, openBookingCheck])

  return (
    <Segment
      style={{ ...styles.container, ...(isCareTeam && { padding: 0 }) }}
      vertical
    >
      <Container>
        {!isCareTeam && (
          <p style={styles.returnText} onClick={goToProviders}>
            Return to search results
          </p>
        )}
        <Grid style={styles.content(isCareTeam)}>
          <Grid.Column
            mobile={4}
            tablet={3}
            computer={2}
            largeScreen={2}
            style={{ padding: 0 }}
          >
            {provider?.avatar && (
              <Image
                style={{ ...styles.avatar, maxWidth: '100%', height: 'auto' }}
                src={Images[provider?.avatar]}
                alt={
                  provider?.name
                    ? `${provider.name} profile photo`
                    : 'Provider profile photo'
                }
                width={200}
                height={200}
                unoptimized
              />
            )}
          </Grid.Column>
          <Grid.Column
            mobile={12}
            tablet={isCareTeam ? 13 : 8}
            computer={isCareTeam ? 8 : 10}
            largeScreen={10}
            style={styles.infoColumnContainer(isCareTeam)}
          >
            <ProviderInfo
              name={provider?.name}
              specialization={provider?.specialization}
              rating={provider?.rating}
              isInNetwork={provider?.isInNetwork}
            />
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={isCareTeam ? 16 : 5}
            computer={isCareTeam ? 6 : 4}
            largeScreen={4}
            style={styles.buttonsContainer(isMobile, isTablet)}
          >
            <Button onClick={openBookingModal} style={styles.button}>
              Book Online
            </Button>
            {isCareTeam ? (
              <Button onClick={goToMessages} style={styles.secondaryButton}>
                Send a message
              </Button>
            ) : (
              <Button
                href={`tel:${provider?.phone}`}
                style={styles.secondaryButton}
              >
                CALL
              </Button>
            )}
          </Grid.Column>
        </Grid>
        <ProfileOverview provider={provider} />
      </Container>
      {isCanOpenModal && (
        <AppointmentBookingModal
          provider={provider}
          isBookingDataLoading={isBookingDataLoading}
          bookingData={bookingData}
          onGetBookingData={getBookingData}
          isBookAppointmentLoading={isBookAppointmentLoading}
          bookAppointmentStatus={bookAppointmentStatus}
          onBookAppointment={bookAppointment}
          onResetBooking={resetBooking}
          onOpenBookingCheck={openBookingCheck}
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
        />
      )}
    </Segment>
  )
}
